/* Conversion Dude - PDP leather swatches (all products), shipped from the Intelligems swatch test (Oct 2026).
   iPhone cases: each color's day 1 patina photo from data-cd-leather (snippets/cd-leather-attr.liquid).
   Every other product: zoom on the smoothest leather spot of its product photo (precomputed below,
   analysed in the browser for products added later). Also prefetches a color's page on swatch
   hover/touch/focus, since each color is its own product page.
   Loaded by blocks/sibling-color-swatches.liquid together with assets/cd-leather-swatches.css. */
(function () {
  "use strict";
  if (window.cdLeatherSwatches) return;
  window.cdLeatherSwatches = true;
  /* PDPs only; the landing pages (?view=lp-...) keep their own swatches */
  if (!/\/products\//.test(location.pathname)) return;
  var LP = /[?&]view=lp-/.test(location.search);
  if (LP) { document.documentElement.classList.add("cd-leather-off"); }
  var MOBILE = window.matchMedia("(max-width: 749px)");

  /* Precomputed leather spot per product photo: [zoom %, x %, y %] (Oct 9, all 166 non-case products).
     Same algorithm as analyze() below, which only runs for products added later. */
  var T = {"the-performance-leather-navsafe-wallet-carbon":[500,40.8,81.7],"leather-navsafe-wallet-oxblood":[500,55.4,75.8],"sienna-magsafe-iphone-cases":[500,61.2,81.7],"leather-macbook-shell-black":[500,26.2,72.9],"leather-macbook-shell-sienna":[500,40.8,72.9],"the-performance-leather-magsafe-wallet-cocoa":[500,40.8,81.7],"last-chance-leather-navsafe-wallet-maverick":[500,55.4,75.8],"last-chance-leather-airpods-cases-maverick":[500,58.3,55.4],"last-chance-leather-apple-watch-strap-maverick-copy":[1250,27.2,47.8],"last-chance-leather-magnetic-wallet-maverick":[500,40.8,70.0],"bullstrap-reserve-trackable-messenger-wallet":[500,43.8,84.6],"bullstrap-reserve-trackable-bifold-wallet":[500,67.1,67.1],"bullstrap-reserve-trackable-card-holder":[500,23.3,67.1],"leather-magnetic-wallet-evergreen":[500,43.8,67.1],"leather-navsafe-wallet-evergreen":[500,55.4,72.9],"leather-magsafe-wallet-maverick":[500,40.8,70.0],"sienna-leather-nav-bifold-wallet":[500,35.0,40.8],"the-trace-trackable-keychain-black":[500,49.6,84.6],"the-trace-trackable-keychain-sienna":[500,49.6,64.2],"free-leather-navsafe-wallet-sienna":[500,58.3,75.8],"free-leather-navsafe-wallet-ocean":[500,43.8,75.8],"free-leather-navsafe-wallet-black-edition":[500,43.8,75.8],"free-leather-navsafe-wallet-terra":[500,43.8,78.8],"free-leather-navsafe-wallet-slate":[500,46.7,75.8],"free-leather-navsafe-wallet-maverick":[500,58.3,75.8],"free-leather-navsafe-wallet-south-beach":[500,55.4,75.8],"free-leather-navsafe-wallet-dune":[500,58.3,75.8],"leather-nav-card-holder-slate":[500,58.3,75.8],"leather-nav-card-holder-ocean":[500,26.2,75.8],"leather-nav-card-holder-terra":[500,40.8,72.9],"leather-nav-messenger-wallet-ocean":[500,37.9,84.6],"leather-nav-messenger-wallet-slate":[500,46.7,84.6],"leather-nav-messenger-wallet-terra":[500,46.7,84.6],"leather-nav-bifold-wallet-ocean":[500,55.4,75.8],"leather-nav-bifold-wallet-slate":[500,32.1,75.8],"leather-nav-bifold-wallet-terra":[500,43.8,75.8],"the-carrie-wristlet-buttercream":[789,64.1,67.2],"final-sale-leather-airpods-cases-1":[500,75.8,32.1],"final-sale-magnetic-popper-wallet-non-leather":[500,40.8,72.9],"enjoy-your-journey-tee-charcoal":[500,81.7,35.0],"samsung-galaxy-s25-ultra-case-sienna":[500,58.3,87.5],"samsung-galaxy-s25-ultra-case-ocean":[500,55.4,87.5],"samsung-galaxy-s25-ultra-case-terra":[500,40.8,84.6],"samsung-galaxy-s25-ultra-case-slate":[500,40.8,70.0],"samsung-galaxy-s25-ultra-case-black":[500,46.7,87.5],"the-haven-trackable-wallet-saddle":[500,26.2,70.0],"the-haven-trackable-wallet-desert-bloom":[500,26.2,70.0],"the-haven-trackable-wallet-bluebelle":[500,26.2,70.0],"the-dolly-trackable-wallet-saddle":[500,26.2,64.2],"the-dolly-trackable-wallet-desert-bloom":[500,81.7,61.2],"the-dolly-trackable-wallet-bluebelle":[500,23.3,61.2],"commuter-backpack":[500,46.7,81.7],"final-sale-leather-desk-mat":[789,48.9,93.1],"leather-ipad-case-terra-copy":[500,35.0,11.7],"leather-apple-watch-strap-modern-terra":[1250,37.0,19.6],"leather-apple-watch-strap-bourbon":[1250,37.0,19.6],"bulltag-for-airtag-terra-1":[500,55.4,75.8],"leather-navsafe-wallet-maverick":[500,55.4,75.8],"leather-airpods-cases-maverick":[500,58.3,55.4],"non-leather-popper":[500,40.8,72.9],"warranty-replacement-maverick":[500,55.4,84.6],"the-magsafe-power-bank":[500,46.7,70.0],"bullstrap-reserve-the-odyssey-travel-bag":[500,46.7,61.2],"leather-laptop-sleeve-ocean":[500,49.6,81.7],"leather-laptop-sleeve-slate":[500,35.0,20.4],"leather-laptop-sleeve-terra":[500,64.2,84.6],"leather-magnetic-wallet-copy":[500,58.3,72.9],"leather-ipad-case-terra":[500,40.8,87.5],"leather-ipad-case-slate":[500,26.2,81.7],"leather-nav-card-holder-black-edition":[500,35.0,72.9],"leather-nav-card-holder-sienna":[500,26.2,72.9],"leather-nav-messenger-wallet-black-edition":[500,46.7,81.7],"leather-nav-messenger-wallet-sienna":[500,49.6,70.0],"leather-nav-bifold-wallet-black-edition":[500,78.8,64.2],"leather-nav-wallet-sienna":[500,37.9,52.5],"leather-navsafe-wallet-dune":[500,58.3,75.8],"leather-navsafe-wallet-south-beach":[500,58.3,75.8],"leather-navsafe-wallet-slate":[500,46.7,75.8],"leather-navsafe-wallet-terra":[500,43.8,75.8],"leather-navsafe-wallet-black-edition":[500,40.8,75.8],"leather-navsafe-wallet-sienna-copy":[500,40.8,75.8],"leather-navsafe-wallet-sienna":[500,58.3,75.8],"leather-airpods-cases-slate":[500,70.0,55.4],"magsafe-charging-cable":[500,70.0,55.4],"the-magsafe-charging-cable":[500,29.2,43.8],"the-signature-belt-black":[789,48.9,0.0],"rugged-leather-belt-black-edition":[789,51.9,7.6],"lifetime-supply-of-charging-cables":[1250,50.0,48.9],"leather-magnetic-wallet":[500,58.3,72.9],"bulltag-for-airtag-slate":[500,49.6,78.8],"bulltag-for-airtag-dune":[500,49.6,75.8],"bulltag-for-airtag-south-beach":[500,49.6,75.8],"bulltag-for-airtag-ocean":[500,49.6,78.8],"bulltag-for-airtag-sienna":[500,49.6,78.8],"bulltag-for-airtag-black-edition":[500,52.5,78.8],"sienna-the-popper":[500,78.8,72.9],"leather-magsafe-wallet-terra":[500,58.3,70.0],"the-popper-sienna":[500,78.8,72.9],"the-popper-black-edition":[500,75.8,72.9],"leather-rugged-backpack-black-edition":[500,55.4,26.2],"rugged-leather-belt-terra":[500,49.6,23.3],"leather-rugged-backpack-terra":[500,49.6,23.3],"bullstrap-reserve-the-signature-belt":[789,48.9,19.8],"leather-ipad-pro-case-ocean":[500,72.9,87.5],"leather-magsafe-wallet-slate":[500,43.8,72.9],"leather-desk-mat-black-edition":[789,48.9,93.1],"leather-desk-mat-sienna":[789,48.9,93.1],"metal-apple-watch-strap-gold":[1250,38.0,39.1],"leather-laptop-sleeve-sienna":[500,52.5,49.6],"leather-laptop-sleeve-dune":[500,49.6,75.8],"leather-laptop-sleeve-black-edition":[500,35.0,84.6],"leather-apple-watch-strap-south-beach":[1250,39.1,20.7],"leather-airpods-cases-south-beach":[500,64.2,52.5],"leather-ipad-pro-case-black-edition":[500,58.3,90.4],"leather-ipad-pro-case-dune":[500,32.1,90.4],"leather-ipad-pro-case-sienna":[500,29.2,11.7],"bullstrap-reserve-the-dopp-kit":[500,26.2,70.0],"leather-magsafe-wallet-south-beach":[500,37.9,70.0],"leather-airpods-cases-dune":[500,64.2,55.4],"leather-apple-watch-strap-dune":[1250,28.3,50.0],"bifold-wallet-black-edition":[500,32.1,68.9],"leather-magsafe-wallet-dune":[500,40.8,72.9],"leather-apple-watch-strap-black-edition":[1250,29.3,51.1],"leather-apple-watch-strap-ocean":[1250,28.3,51.1],"leather-apple-watch-strap-sienna":[1250,35.9,18.5],"the-messenger-wallet-black-edition":[500,45.0,18.0],"the-eyj-patch-hat-tan":[500,72.9,43.8],"the-eyj-patch-hat-black":[500,72.9,70.0],"leather-airpods-case-sienna":[500,43.8,67.1],"leather-airpods-case-ocean":[500,49.6,67.1],"leather-airpods-case-bourbon":[500,26.2,70.0],"leather-magsafe-wallet-black-edition":[500,61.2,72.9],"enjoy-the-journey-dad-hat-tan":[500,23.3,72.9],"messenger-wallet":[500,48.0,84.0],"leather-magsafe-wallet-sienna":[500,58.3,72.9],"leather-magsafe-wallet-ocean":[500,46.7,75.8],"bullstrap-bifold-wallet-terra":[500,64.2,66.7],"bullstrap-money-clip-black-edition":[500,61.2,61.2],"the-charging-cable":[1250,50.0,48.9],"leather-airpods-case-terra":[500,46.7,67.1],"leather-airpods-case-black-edition":[500,52.5,67.1],"metal-silver":[1250,34.8,43.5],"metal-black-edition":[1250,38.0,44.6],"bullstrap-card-holder-black":[500,29.2,68.9],"bullstrap-card-holder-terra":[500,52.5,60.0],"bullstrap-money-clip-terra":[500,43.8,61.2],"black-edition-bullstrap":[1250,31.5,53.3],"classic-bullstrap":[1250,38.0,23.9],"terra-bullstrap":[1250,38.0,23.9]};

  function paint(a, url, size, posX, posY) {
    var c = a.querySelector(".sibling-color-swatches__color");
    if (!c || c.classList.contains("cd-leather-swatch")) return;
    c.classList.add("cd-leather-swatch");
    c.style.setProperty("background-color", "#d9d2c5", "important");
    c.style.setProperty("background-image", "url('" + url + "')", "important");
    c.style.setProperty("background-size", size + "% auto", "important");
    c.style.setProperty("background-repeat", "no-repeat", "important");
    c.style.setProperty("background-position", posX + "% " + posY + "%", "important");
  }

  /* Leather images: keep the row hidden until they're downloaded, so it appears complete */
  var loaded = {};
  function isLoaded(url) {
    if (loaded[url] === 1) return true;
    if (!loaded[url]) {
      loaded[url] = 2;
      var im = new Image();
      im.onload = im.onerror = function () { loaded[url] = 1; apply(); };
      im.src = url;
      if (im.complete) loaded[url] = 1;
    }
    return loaded[url] === 1;
  }
  var forceShow = false;
  setTimeout(function () { forceShow = true; apply(); }, 1500);

  /* Results for products not in T are cached per photo and per product. */
  var CACHE_KEY = "cdLeatherAuto2";
  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}") || {}; } catch (e) {}
  function saveCache() { try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {} }
  function absolute(u) { return u.indexOf("//") === 0 ? location.protocol + u : u; }
  function handleOf(a) { var m = (a.getAttribute("href") || "").match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  function analyze(img) {
    var W = img.naturalWidth, H = img.naturalHeight;
    if (!W || !H) return null;
    var cv = document.createElement("canvas");
    cv.width = W; cv.height = H;
    var ctx = cv.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    var d = ctx.getImageData(0, 0, W, H).data;
    var L = new Float32Array(W * H), bad = new Uint8Array(W * H), i, x, y;
    for (i = 0; i < W * H; i++) {
      var r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2], al = d[i * 4 + 3];
      var l = 0.299 * r + 0.587 * g + 0.114 * b;
      L[i] = l;
      bad[i] = al < 250 || (l > 238 && Math.max(r, g, b) - Math.min(r, g, b) < 12) ? 1 : 0;
    }
    var W1 = W + 1, SE = new Float64Array(W1 * (H + 1)), SB = new Float64Array(W1 * (H + 1));
    for (y = 0; y < H; y++) {
      var re = 0, rb = 0;
      for (x = 0; x < W; x++) {
        i = y * W + x;
        var e = (x < W - 1 && y < H - 1) ? Math.abs(L[i] - L[i + 1]) + Math.abs(L[i] - L[i + W]) : 0;
        re += e; rb += bad[i];
        SE[(y + 1) * W1 + x + 1] = SE[y * W1 + x + 1] + re;
        SB[(y + 1) * W1 + x + 1] = SB[y * W1 + x + 1] + rb;
      }
    }
    var zooms = [5, 8, 12.5];
    for (var zi = 0; zi < zooms.length; zi++) {
      var z = zooms[zi], win = Math.max(8, Math.round(W / z)), n = win * win, step = Math.max(2, win >> 3), best = null;
      for (y = 0; y + win < H; y += step) {
        for (x = 0; x + win < W; x += step) {
          var a0 = y * W1 + x, a1 = y * W1 + x + win, a2 = (y + win) * W1 + x, a3 = (y + win) * W1 + x + win;
          if (SB[a3] - SB[a1] - SB[a2] + SB[a0] > n * 0.005) continue;
          var edge = (SE[a3] - SE[a1] - SE[a2] + SE[a0]) / n;
          var dist = Math.sqrt(Math.pow(x + win / 2 - W / 2, 2) + Math.pow(y + win / 2 - H / 2, 2)) / W;
          var sc = edge + 0.3 * dist;
          if (!best || sc < best[0]) best = [sc, x, y];
        }
      }
      if (best) {
        return [
          Math.round(W / win * 100),
          W > win ? Math.round(best[1] / (W - win) * 1000) / 10 : 50,
          H > win ? Math.round(best[2] / (H - win) * 1000) / 10 : 50
        ];
      }
    }
    return null;
  }

  /* Photo for a swatch: the theme attribute when present, else the product's public JSON. */
  function photoFor(a, done) {
    var u = a.getAttribute("data-cd-leather-auto");
    if (u) return done(absolute(u));
    var h = handleOf(a);
    if (!h) return done(null);
    var key = "h:" + h;
    if (cache[key]) return done(cache[key] === "x" ? null : cache[key]);
    fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (!src) { cache[key] = "x"; saveCache(); return done(null); }
        src = absolute(src.split("?")[0] + "?width=300");
        cache[key] = src; saveCache(); done(src);
      })
      .catch(function () { done(null); });
  }

  /* [size, x, y, url] for a swatch, "x" if it can't be done, or null while working on it */
  var queued = {};
  function auto(a) {
    var h = handleOf(a);
    var attr = a.getAttribute("data-cd-leather-auto");
    var t = h && T[h];
    if (t && attr) return [t[0], t[1], t[2], absolute(attr)];
    var url = attr ? absolute(attr) : cache["h:" + h];
    if (url === "x") return "x";
    if (url && t) return [t[0], t[1], t[2], url];
    if (url && cache[url]) return cache[url];
    var id = attr || h || "";
    if (!id) return "x";
    if (queued[id]) return null;
    queued[id] = 1;
    photoFor(a, function (src) {
      if (!src) { queued[id] = 0; apply(); return; }
      if (t || cache[src]) { apply(); return; }
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        var res = null;
        try { res = analyze(img); } catch (e) {}
        cache[src] = res ? [res[0], res[1], res[2], src] : "x";
        loaded[src] = 1;
        saveCache();
        apply();
      };
      img.onerror = function () { cache[src] = "x"; apply(); };
      img.src = src;
    });
    return null;
  }

  function apply() {
    if (LP) return;
    var lists = document.querySelectorAll(".sibling-color-swatches__list");
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.classList.contains("cd-leather-list")) {
        /* re-rendered swatches inside an existing row */
        var fresh = list.querySelectorAll("a.sibling-color-swatches__swatch .sibling-color-swatches__color:not(.cd-leather-swatch)");
        if (!fresh.length) { title(list); continue; }
      }
      var swatches = list.querySelectorAll("a.sibling-color-swatches__swatch");
      var any = false, pending = false, ready = true;
      for (var j = 0; j < swatches.length; j++) {
        var a = swatches[j];
        var url = a.getAttribute("data-cd-leather");
        if (url) {
          any = true;
          paint(a, url, 500, 50, a.getAttribute("data-cd-leather-y") || "60");
          if (!isLoaded(url)) ready = false;
        } else {
          var hit = auto(a);
          if (hit === null) pending = true;
          else if (hit !== "x") {
            any = true;
            paint(a, hit[3], hit[0], hit[1], hit[2]);
            if (!isLoaded(hit[3])) ready = false;
          }
        }
      }
      if (!swatches.length) continue;
      if (any && ((!pending && ready) || forceShow)) {
        list.classList.add("cd-leather-list");
        title(list);
      } else if ((!any && !pending) || forceShow) {
        list.classList.add("cd-leather-skip");
      }
    }
  }

  /* Mobile only: bigger product title next to the big swatches. Set inline because the theme's
     title rule is too specific for CSS. Desktop keeps the theme's own title size. */
  function title(list) {
    var info = list.closest(".product-information");
    var h1 = info && info.querySelector(".product-details h1");
    if (!h1) return;
    if (MOBILE.matches) {
      if (h1.style.fontSize !== "1.55rem") h1.style.setProperty("font-size", "1.55rem", "important");
    } else if (h1.style.fontSize) {
      h1.style.removeProperty("font-size");
    }
  }

  var booted = false;
  function boot() {
    if (!document.body) { setTimeout(boot, 30); return; }
    apply();
    if (booted) return;
    booted = true;
    try {
      var pending = false;
      /* paint as soon as the swatch row is parsed, and again when the PDP re-renders it */
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; apply(); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    if (MOBILE.addEventListener) MOBILE.addEventListener("change", apply);
  }
  boot();
  document.addEventListener("DOMContentLoaded", boot);

  /* Faster color switch: each color is its own page, so prefetch it as soon as the shopper
     hovers, touches or focuses a swatch. */
  function cdPrefetch(e) {
    var a = e.target && e.target.closest && e.target.closest("a.sibling-color-swatches__swatch[href]");
    if (!a || a.classList.contains("sibling-color-swatches__swatch--selected")) return;
    var href = a.href;
    if (!href || cdPrefetch.done[href]) return;
    cdPrefetch.done[href] = 1;
    var l = document.createElement("link");
    l.rel = "prefetch";
    l.href = href;
    document.head.appendChild(l);
  }
  cdPrefetch.done = {};
  ["pointerover", "touchstart", "focusin"].forEach(function (ev) {
    document.addEventListener(ev, cdPrefetch, { passive: true, capture: true });
  });
})();
